<template>
  <v-dialog v-model="dialog" persistent max-width="440" content-class="auth-dialog">
    <v-card class="auth-card" elevation="12">
      <div class="auth-card__header">
        <div class="auth-card__icon">
          <v-icon color="white" size="30">mdi-lock-reset</v-icon>
        </div>
        <h1 class="auth-card__title">Mot de passe oublié</h1>
        <p class="auth-card__subtitle mb-0">
          Indiquez votre e-mail pour recevoir le lien de réinitialisation
        </p>
      </div>

      <v-card-text class="auth-card__content">
        <v-form ref="loginForm" v-model="valid" lazy-validation @submit.prevent="validate">
          <v-text-field
            v-model="loginEmail"
            :rules="emailRules"
            label="Adresse e-mail"
            prepend-inner-icon="mdi-email-outline"
            autocomplete="email"
            outlined
            required
          />

          <v-alert v-if="verified" :type="error ? 'error' : 'success'" dense text class="mb-4">
            {{ message }}
          </v-alert>

          <v-btn
            v-if="!verified || error"
            type="submit"
            :disabled="!valid"
            color="primary"
            depressed
            large
            block
          >
            <v-icon left>mdi-email-send-outline</v-icon>
            Envoyer le lien
          </v-btn>

          <v-btn text block color="primary" class="auth-card__back mt-3" @click="retour">
            <v-icon left small>mdi-arrow-left</v-icon>
            Retour à la connexion
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ForgotPasswordComponent',
  data() {
    return {
      dialog: true,
      valid: true,
      message: '',
      loginEmail: '',
      error: false,
      verified: false,
      emailRules: [
        value => !!value || 'E-mail requis',
        value => /.+@.+\..+/.test(value) || 'Saisissez une adresse e-mail valide'
      ]
    }
  },
  methods: {
    validate() {
      if(!this.$refs.loginForm.validate()) return

      this.API({
        type: 'post',
        url: '/auth/sendForgot',
        params: { email: this.loginEmail }
      }).then(response => {
        this.verified = true
        this.error = !response.data.success
        this.message = response.data.message
      })
    },
    retour() {
      this.$router.push({ name: 'login' })
    }
  },
  created() {
    if(this.$store.getters.systemLoad) window.location.href = '/'
  }
}
</script>

<style scoped>
::v-deep .auth-dialog {
  margin: 12px;
  border-radius: 16px;
}
.auth-card {
  overflow: hidden;
  border-radius: 16px !important;
}
.auth-card__header {
  padding: 30px 28px 28px;
  color: #fff;
  text-align: center;
  background: linear-gradient(135deg, #283593 0%, #1565c0 100%);
}
.auth-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 58px;
  margin-bottom: 14px;
  border: 1px solid rgba(255, 255, 255, .32);
  border-radius: 16px;
  background: rgba(255, 255, 255, .14);
}
.auth-card__title {
  margin: 0 0 4px;
  font-size: 1.55rem;
  font-weight: 600;
  line-height: 1.3;
}
.auth-card__subtitle {
  color: rgba(255, 255, 255, .82);
  font-size: .92rem;
  line-height: 1.45;
}
.auth-card__content { padding: 30px 32px 26px !important; }
.auth-card__back { text-transform: none; letter-spacing: normal; }
@media (max-width: 600px) {
  .auth-card__header { padding: 24px 20px 22px; }
  .auth-card__content { padding: 24px 20px 20px !important; }
}
</style>
